(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = global || self, factory(global.Tooltips = {}));
}(this, (function (exports) { 'use strict';

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function styleInject(css, ref) {
    if ( ref === void 0 ) ref = {};
    var insertAt = ref.insertAt;

    if (!css || typeof document === 'undefined') { return; }

    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';

    if (insertAt === 'top') {
      if (head.firstChild) {
        head.insertBefore(style, head.firstChild);
      } else {
        head.appendChild(style);
      }
    } else {
      head.appendChild(style);
    }

    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }
  }

  var css_248z = "[pros-tooltip]{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}pros-tooltip-overlay{background-color:#5a5a5a;color:#fff;width:auto;border-radius:4px;padding:4px 8px;margin-top:4px;transform:translateX(-50%);z-index:1000001;font-family:Roboto,Helvetica Neue,sans-serif;font-size:12px;font-weight:500;text-align:center;white-space:nowrap;pointer-events:none;user-select:none}pros-tooltip-overlay,pros-tooltip-overlay *,pros-tooltip-overlay :after,pros-tooltip-overlay :before{box-sizing:border-box}";
  styleInject(css_248z);

  var Tooltips = /*#__PURE__*/function () {
    function Tooltips() {
      _classCallCheck(this, Tooltips);

      this._observers = new WeakMap();
      this._listeners = {
        mouseenter: new WeakMap(),
        mouseleave: new WeakMap()
      };
    }

    _createClass(Tooltips, [{
      key: "addObserver",
      value: function addObserver() {
        var _this = this;

        var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;

        if (this._observers.get(target)) {
          // Could also throw an error
          return;
        }

        var observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            if (mutation.type !== 'childList') {
              return;
            }

            var addedNodes = mutation.addedNodes;

            for (var i = 0; i < addedNodes.length; i++) {
              var node = addedNodes[i];

              if (!node.querySelectorAll) {
                continue;
              } //Check node itself and then children


              if (node.hasAttribute('pros-tooltip')) {
                _this.bind(node);
              }

              var elements = node.querySelectorAll('[pros-tooltip]');

              if (elements.length > 0) {
                for (var j = 0; j < elements.length; j++) {
                  var element = elements[j];

                  _this.bind(element);
                }
              }
            }

            var removedNodes = mutation.removedNodes;

            for (var _i = 0; _i < removedNodes.length; _i++) {
              var _node = removedNodes[_i];

              if (!_node.querySelectorAll) {
                continue;
              }

              if (_node.hasAttribute('pros-tooltip')) {
                _this.bind(_node);
              }

              var _elements = _node.querySelectorAll('[pros-tooltip]');

              if (_elements.length > 0) {
                for (var _j = 0; _j < _elements.length; _j++) {
                  var _element = _elements[_j];

                  _this.unbind(_element);
                }
              }
            }
          });
        });
        observer.observe(target, {
          childList: true,
          subtree: true,
          attributes: false,
          characterData: false
        });

        this._observers.set(target, observer);
      }
    }, {
      key: "removeObserver",
      value: function removeObserver() {
        var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;

        var observer = this._observers.get(target);

        if (observer) {
          observer.disconnect();

          this._observers["delete"](target);
        }
      }
    }, {
      key: "bind",
      value: function bind(el) {
        var _this2 = this;

        var listener = function listener() {
          var attributeValue = el.getAttribute('pros-tooltip');

          if (!attributeValue && isFullContentVisible(el)) {
            // not specified and text not truncated - don't show tooltip
            return;
          }

          var tooltipEl = document.createElement('pros-tooltip-overlay');
          setContent(tooltipEl, el);
          setPosition(tooltipEl, el); // Hide, then append to get width, then show once width corrected.
          // Approach from http://stackoverflow.com/a/2930159/277307

          hideElement(tooltipEl);
          document.body.appendChild(tooltipEl);
          ensureEvenWidth(tooltipEl);
          ensureNotClipped(tooltipEl);
          showElement(tooltipEl);
          removeOnMouseLeave.call(_this2, tooltipEl, el);
        };

        var enterListener = this._listeners.mouseenter.get(el);

        if (!enterListener) {
          el.addEventListener('mouseenter', listener);

          this._listeners.mouseenter.set(el, listener);
        }
      }
    }, {
      key: "unbind",
      value: function unbind(el) {
        var enterListener = this._listeners.mouseenter.get(el);

        if (enterListener) {
          el.removeEventListener('mouseenter', enterListener);

          this._listeners.mouseenter["delete"](el);
        }

        var leaveListener = this._listeners.mouseleave.get(el);

        if (leaveListener) {
          leaveListener.call(this);
        }
      }
    }]);

    return Tooltips;
  }(); // Adapted from http://stackoverflow.com/a/10017343/277307

  function isFullContentVisible(el) {
    return el.offsetWidth >= el.scrollWidth;
  }

  function setPosition(tooltipEl, el) {
    tooltipEl.style.position = 'fixed';
    var elRect = el.getBoundingClientRect();
    tooltipEl.style.top = elRect.top + elRect.height + 'px'; // Center horizontally under element

    tooltipEl.style.left = elRect.left + elRect.width / 2 + 'px';
    return tooltipEl;
  }

  function setContent(tooltipEl, el) {
    var attrValue = el.getAttribute('pros-tooltip');

    if (attrValue) {
      // Use value if provided
      tooltipEl.textContent = attrValue;
    } else {
      // Element text by default
      tooltipEl.textContent = el.textContent;
    }

    return tooltipEl;
  }

  function removeOnMouseLeave(tooltipEl, el) {
    var _this3 = this;

    var leaveHandler = function leaveHandler() {
      document.body.removeChild(tooltipEl);
      el.removeEventListener('mouseleave', leaveHandler);

      _this3._listeners.mouseleave["delete"](el);
    };

    el.addEventListener('mouseleave', leaveHandler);

    this._listeners.mouseleave.set(el, leaveHandler);
  }

  function hideElement(tooltipEl) {
    tooltipEl.style.visibility = 'hidden';
  }

  function showElement(tooltipEl) {
    tooltipEl.style.removeProperty('visibility');
  } // Necessary because of chrome font antialiasing with translations on odd widths
  // will cause blurry text. See http://stackoverflow.com/a/41456864/277307


  function ensureEvenWidth(tooltipEl) {
    var width = Math.round(tooltipEl.getBoundingClientRect().width);

    if (width % 2 !== 0) {
      width++;
    }

    tooltipEl.style.width = width + 'px';
  }

  function ensureNotClipped(tooltipEl) {
    // Ensure not clipped by window boundary,
    // since we're transforming left 50% and width could exceed the window.
    var rect = tooltipEl.getBoundingClientRect();
    var halfWidth = rect.width / 2;

    if (rect.left < 0) {
      tooltipEl.style.left = halfWidth + 'px';
    } else if (rect.right > window.innerWidth) {
      tooltipEl.style.left = window.innerWidth - halfWidth + 'px';
    }
  }

  exports.Tooltips = Tooltips;

  Object.defineProperty(exports, '__esModule', { value: true });

})));



//////////////////
// WEBPACK FOOTER
// ../~/@printos/agnostic-tooltips/dist/tooltips.js
// module id = 79
// module chunks = 0